"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightEdit = exports.className = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ListEdit_1 = require("../../Allotment/ListEdit");
const utils_1 = require("../../Allotment/ListEdit/Seats/utils");
const Button_1 = require("../../Button");
const Info_1 = require("./Info");
const Repeating_1 = require("./Repeating");
require("./index.scss");
exports.className = 'flight-edit';
const FlightEdit = (props) => {
    var _a, _b, _c, _d;
    const { info, tariff, templateSettings, allotment, repeating, submit, isSubmitDisabled, notifyIncorrectForm, } = props;
    const [isSequence, setIsSequence] = (0, react_1.useState)(false);
    const validationsRef = (0, react_1.useRef)({
        validateInfo: () => false,
        validateTariff: () => false,
        validateAllotment: () => false,
        validateRepeating: () => false,
    });
    const handleSubmit = () => {
        const { validateInfo, validateTariff, validateAllotment, validateRepeating } = validationsRef.current;
        const isInfoValid = validateInfo();
        const isTariffValid = validateTariff();
        const isAllotmentValid = !allotment.allowed || validateAllotment();
        const isRepeatingValid = !isSequence || validateRepeating();
        if (!isInfoValid || !isTariffValid || !isAllotmentValid || !isRepeatingValid) {
            notifyIncorrectForm === null || notifyIncorrectForm === void 0 ? void 0 : notifyIncorrectForm();
            return;
        }
        submit(isSequence);
    };
    const infoEditProps = {
        info: {
            ...info,
            setValidateRef: (x) => validationsRef.current.validateInfo = x,
        },
        tariff: {
            ...tariff,
            setValidateRef: (x) => validationsRef.current.validateTariff = x,
        },
        templateSettings,
    };
    const allotmentsEditProps = {
        addAllotmentField: allotment.addAllotmentField,
        removeHidden: allotment.removeHidden,
        values: allotment.propsValues,
        config: allotment.config,
        onChange: allotment.onChange,
        tariffGroups: tariff.tariffGroups,
        totalSeats: (0, utils_1.calcTotalSeats)(tariff.tariffGroups, (_a = info.propsValues) === null || _a === void 0 ? void 0 : _a.seatsByTariff, !((_c = (_b = tariff.config) === null || _b === void 0 ? void 0 : _b.totalSeats) === null || _c === void 0 ? void 0 : _c.hidden)),
        setValidateRef: (x) => validationsRef.current.validateAllotment = x,
    };
    const repeatingEditProps = {
        ...repeating,
        setValidateRef: (x) => validationsRef.current.validateRepeating = x,
        departure: (_d = info.propsValues) === null || _d === void 0 ? void 0 : _d.departure,
        isSequence,
        setIsSequence,
    };
    return (react_1.default.createElement("div", { className: exports.className },
        react_1.default.createElement(Info_1.FlightInfoEdit, { ...infoEditProps }),
        allotment.allowed && (react_1.default.createElement(ListEdit_1.AllotmentsEdit, { ...allotmentsEditProps })),
        repeating.allowed && (react_1.default.createElement(Repeating_1.FlightRepeatingEdit, { ...repeatingEditProps })),
        react_1.default.createElement("div", { className: `${exports.className}__button` },
            react_1.default.createElement(Button_1.Button, { icon: 'save', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:Save', defaultMessage: 'Save' }), type: 'submit', onClick: handleSubmit, disabled: isSubmitDisabled }))));
};
exports.FlightEdit = FlightEdit;
//# sourceMappingURL=index.js.map